import React from "react";
import { FaGooglePlay, FaHeartbeat, FaUserNurse } from "react-icons/fa";
import { HiLightBulb } from "react-icons/hi";
import imageApps from "../Assets/tampilan-apps.png";
import imageLansiaIllustration from "../Assets/Illustration Lansia.png";
import logoSigesit from "../Assets/logo_sigesit_v2.png";

const Homepage = () => {
	return (
		<div className="min-h-screen flex flex-col bg-white text-gray-800">
			<header className="bg-white/80 backdrop-blur sticky top-0 z-50 shadow-sm">
				<div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
					{/* Logo & Brand */}
					<div className="flex items-center space-x-2">
						<img
							src={logoSigesit}
							alt="Logo Si-Gesit"
							className="w-20 sm:w-28"
						/>
					</div>
					{/* Navigation */}
					<nav className="hidden md:flex items-center space-x-6 text-sm font-medium text-gray-700">
						<a
							href="#tentang"
							className="hover:text-teal-600"
						>
							Tentang
						</a>
						<a
							href="#fitur"
							className="hover:text-teal-600"
						>
							Fitur
						</a>
						<a
							href="#tampilan"
							className="hover:text-teal-600"
						>
							Tampilan
						</a>
						<a
							href="#download"
							className="bg-teal-600 text-white px-4 py-2 rounded-full shadow hover:bg-teal-700 transition"
						>
							Download
						</a>
					</nav>
				</div>
			</header>
			{/* Hero */}
			<section
				className="p-8 relative bg-cover bg-center bg-no-repeat text-white"
				style={{
					backgroundImage: `url(${imageLansiaIllustration})`,
					backgroundPosition: "center 15%",
				}}
			>
				{/* Overlay gradasi hijau transparan */}
				<div className="absolute inset-0 bg-gradient-to-b from-teal-700/80 to-teal-500/80"></div>
				{/* Content */}
				<div className="relative z-10 px-6 py-24 flex flex-col items-center justify-center text-center max-w-3xl mx-auto">
					<h1 className="text-4xl md:text-5xl font-bold mb-4">
						Selamat Datang di <br /> <p className="my-2">Si-Gesit Lansia</p>
					</h1>
					<p className="text-lg md:text-xl mb-6">
						Aplikasi pendamping lansia untuk pemantauan kesehatan, edukasi, dan pemeriksaan rutin.
					</p>
					{/* Tombol Download */}
					<div
						id="download"
						className="flex flex-col items-center space-y-3 md:flex-row md:space-y-0 md:space-x-4 mt-4"
					>
						{/* Tombol Play Store */}
						<a
							href="https://play.google.com/store/apps/details?id=com.sigesitapp"
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex items-center px-6 py-3 bg-white text-teal-700 font-semibold rounded-full shadow hover:bg-gray-100 transition"
						>
							<FaGooglePlay className="mr-2 text-2xl" />
							Download di Play Store
						</a>
						<a
							href="/file/sigesitapp-v110.apk"
							download
							className="inline-flex items-center px-6 py-3 bg-yellow-400 text-gray-900 font-semibold rounded-full shadow hover:bg-yellow-300 transition"
						>
							Download APK (sigesitapp-v1.1.0.apk)
						</a>
					</div>
				</div>
			</section>
			{/* Tentang Aplikasi */}
			<section
				id="tentang"
				className="py-16 px-6 max-w-5xl mx-auto text-center"
			>
				<h2 className="text-3xl font-bold mb-6">Apa itu Si-Gesit Lansia?</h2>
				<p className="text-lg text-gray-700">
					Si-Gesit (Sistem Informasi Gerakan Sehat dan Inovatif Terintegrasi) Lansia adalah aplikasi
					berbasis mobile yang membantu lansia, dan tenaga kesehatan dalam mencatat, memantau, dan
					memberi saran kesehatan secara digital.
				</p>
			</section>
			{/* Fitur Unggulan */}
			<section
				id="fitur"
				className="bg-gray-100 py-16 px-6"
			>
				<div className="max-w-5xl mx-auto">
					<h2 className="text-3xl font-bold text-center mb-10">Fitur Unggulan</h2>
					<div className="grid grid-cols-1 md:grid-cols-3 gap-8">
						{[
							{
								title: "Pemantauan Kesehatan",
								desc: "Catat hasil pemeriksaan rutin seperti tekanan darah, gula darah, dan lainnya.",
								icon: <FaHeartbeat className="text-teal-500 text-5xl mx-auto mb-4" />,
							},
							{
								title: "Saran Kesehatan Otomatis",
								desc: "Dapatkan rekomendasi dan edukasi berdasarkan kondisi kesehatan Anda.",
								icon: <HiLightBulb className="text-yellow-500 text-5xl mx-auto mb-4" />,
							},
							{
								title: "Akses untuk Nakes",
								desc: "Petugas kesehatan dapat membantu memantau data lansia.",
								icon: <FaUserNurse className="text-indigo-500 text-5xl mx-auto mb-4" />,
							},
						].map((f, i) => (
							<div
								key={i}
								className="bg-white rounded-xl shadow p-6 text-center"
							>
								{f.icon}
								<h3 className="text-xl font-semibold mb-2">{f.title}</h3>
								<p className="text-gray-600">{f.desc}</p>
							</div>
						))}
					</div>
				</div>
			</section>
			{/* Gambar Aplikasi */}
			<section
				id="tampilan"
				className="py-16 px-6 max-w-5xl mx-auto text-center"
			>
				<h2 className="text-3xl font-bold mb-6">Tampilan Aplikasi</h2>
				<img
					src={imageApps}
					alt="Tampilan Aplikasi Si-Gesit"
					className="w-full max-w-md mx-auto rounded-xl shadow-lg"
				/>
				<p className="text-sm text-gray-500 mt-2">*Gambar hanya ilustrasi</p>
			</section>
			{/* Footer */}
			<footer className="bg-teal-600 text-white text-center py-6">
				<p>© {new Date().getFullYear()} Si-Gesit Lansia. All rights reserved.</p>
			</footer>
		</div>
	);
};
export default Homepage;
